module.exports = __webpack_public_path__ + "media/images/sp/accessories/men/men_04_thumb-7235c5f2a7e0adbf2949bcbef76a76c0.jpg";